import React from 'react';
import PropTypes from 'prop-types';

import {Box} from "@mui/material";

import {greyishBlue100} from "assets/jss/main";
import {UserAgentUtils} from "../../../../../../utils/useragent";

TopTableHeaderContainer.propTypes = {
    children: PropTypes.node,
};

function TopTableHeaderContainer(props) {
    const isMobile = UserAgentUtils.isMobile();

    return (
        <Box
            sx={{
                backgroundColor: isMobile ? 'none' : "#fff",
                borderRadius: isMobile ? '0' : "12px 12px 0px 0px",
                border: isMobile ? 'none' : `1px solid ${greyishBlue100}`,
                borderBottom:'none',
                p: { xs: "0px", sm: "24px" },
            }}
        >
            <Box sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
                alignItems: { xs: "flex-start", sm: "center" },
                gap: { xs: 2, sm: 0 },
                mb: 1,
            }}>
                {props.children}
            </Box>
        </Box>
    );
}

export default TopTableHeaderContainer;
